import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { RippleModule } from 'primeng/ripple';
import { IDevicePicture } from '@app/api/interfaces/device-picture.interface';
import { PictureRotation } from '@app/core/enums/picture-rotation.enum';
import { FormattingDataService } from '@app/core/services/formatting-data/formatting-data.service';

@Component({
  selector: 'gc-picture-gallery-list-item',
  standalone: true,
  imports: [NgClass, RippleModule],
  templateUrl: './picture-gallery-list-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PictureGalleryListItemComponent {
  protected readonly formattingData = inject(FormattingDataService);

  public picture = input.required<IDevicePicture>();

  public modifiedAt = computed(() => this.formattingData.formatDateTime(this.picture()?.modifiedAt));

  public styleClass = input<string>('');

  public pictureSelect = output<IDevicePicture>();

  public onSelect(): void {
    this.pictureSelect.emit(this.picture());
  }

  public currentRotation = computed(() => this.picture().rotation || PictureRotation.Deg0);
}
